import { Pipe, PipeTransform } from '@angular/core';
import {CensusBeneficiary} from '../../types/nso-data-portal/census-data';

@Pipe({
  name: 'beneficiaryType'
})
export class BeneficiaryTypePipe implements PipeTransform {

  transform(beneficiaries: CensusBeneficiary[], type: string): CensusBeneficiary[] {
    if (!beneficiaries || !type) {
      return beneficiaries;
    }
    return beneficiaries.filter(
      beneficiary => {
        // Exclude entries without category type
        if (!beneficiary.beneficiaryCategoryData) {
          return type === 'OTHERS';
        }
        return beneficiary.beneficiaryCategoryData.beneficiaryCategoryType === type;
      }
    );
  }

}
